import { FC, FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'components/Controls';
import { Button } from 'components/Buttons';

type Props = {
  groupName?: string;
  passcode: string;
  onVerified: () => void;
};

const PasscodeGate: FC<Props> = ({ groupName, passcode, onVerified }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (value.trim() === passcode.trim()) {
      onVerified();
      return;
    }
    setError(true);
  };

  return (
    <div className="fixed inset-0 flex justify-center" style={{ background: '#0c141a' }}>
      <div className="relative w-full max-w-lg flex flex-col items-center justify-center h-full px-6">
        {groupName && (
          <p className="text-white text-xl font-semibold text-center mb-2">{groupName}</p>
        )}
        <p className="text-white/60 text-sm text-center mb-6">{t('labels.enterPasscodeToContinue')}</p>
        <form className="w-full max-w-xs" onSubmit={handleSubmit}>
          <label htmlFor="passcode" className="sr-only">{t('labels.passcode')}</label>
          <Input
            id="passcode"
            name="passcode"
            type="password"
            value={value}
            placeholder={t('labels.passcode')}
            onChange={(event) => {
              setValue(event.target.value);
              setError(false);
            }}
            error={error}
            errorText={t('validations.incorrectPasscode')}
          />
          <Button className="primary-button w-full" type="submit">
            {t('buttons.submit')}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default PasscodeGate;
